<template>
    <div>
        <div :id="methodLabelId" class="text-slate-700 text-base font-bold">Method</div>
        <div class="text-sm leading-tight mb-4 text-slate-500">
            The method of HTTP request.
        </div>

        <vx-radio-selection
            :modelValue="props.modelValue"
            class="grid sm:grid-cols-4 gap-2"
            size="sm"
            :aria-labelledby="methodLabelId"
            @update:modelValue="emit('update:modelValue', $event)"
        >
            <vx-radio-selection-item
                v-for="httpMethod in availableHttpMethods()"
                :key="httpMethod.method"
                :value="httpMethod.method"
                :data-test="`http-method-${httpMethod.method}`"
            >
                <vx-badge class="w-full justify-center" size="lg" :color="httpMethod.color">
                    {{ httpMethod.method }}
                </vx-badge>
            </vx-radio-selection-item>
        </vx-radio-selection>
        <div v-if="props.error" class="mt-1 px-0.5 text-xs text-rose-800">{{ props.error }}</div>
    </div>
</template>

<script setup>
import { VxBadge, VxRadioSelection, VxRadioSelectionItem } from '@voxie/frontend-components';
import { useId } from 'vue';
import { availableHttpMethods } from '../apiDestinationHelper';

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: undefined,
    },
});

const emit = defineEmits(['update:modelValue']);

const methodLabelId = useId();
</script>
